// extracted by mini-css-extract-plugin
export default {"modal-header":"AddInventoryModell_modal-header__jfl6v","search-filter__markReceived":"AddInventoryModell_search-filter__markReceived__BFurg"};